import { render, staticRenderFns } from "./OurStoryExpert.vue?vue&type=template&id=48934474&scoped=true&"
import script from "./OurStoryExpert.vue?vue&type=script&lang=js&"
export * from "./OurStoryExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48934474",
  null
  
)

export default component.exports